import {
  fetchSubscriptionList,
  SubscriptionType,
} from "@fd/common/api/fetchSubscriptionList";
import useSWR from "swr";

export const useSubscriptions = (): SubscriptionType[] => {
  const { data: subscriptions } = useSWR(
   "/subscriptions/list",
    fetchSubscriptionList,
  );
  return subscriptions ?? [];
};

export const useActiveSubscriptions = () => {
  const now = new Date();
  const subs = useSubscriptions().filter((sub) => sub.paid_until >= now);
  return subs;
};

export const useOutdatedSubscriptions = () => {
  const now = new Date();
  const subs = useSubscriptions().filter((sub) => sub.paid_until < now);
  return subs;
};
